import React from 'react';

/**
 * Sadly `react-share` v4.x doens't offer an "X" Twitter icon as it was introduced
 * in v5.x. However, v5.x isn't compatible with React.js v16.x, which is what we're using,
 * so we need to come up with an "in-house" implementation for the said icon.
 *
 * The `path` for the SVG icon was taken from the `react-share` repo:
 * https://github.com/nygardk/react-share/blob/18f2de233461984f8197b2ca6d1e0d4969cb78bf/src/XIcon.ts
 *
 * The icon component types and implementation were also taken from the `react-share` repo
 * for compatibility with the rest of the lib:
 * https://github.com/nygardk/react-share/blob/2588f97d2886511630bd34a678323589529cc8eb/src/hocs/createIcon.tsx
 *
 */

type Props = Omit<React.SVGProps<SVGSVGElement>, 'width' | 'height'> & {
  color?: string;
  bgStyle?: React.CSSProperties;
  borderRadius?: number;
  iconFillColor?: string;
  round?: boolean;
  size?: number | string;
};

const XIcon: React.FC<Props> = ({
  bgStyle = {},
  borderRadius = 0,
  iconFillColor = 'white',
  round = false,
  size = 64,
  color,
  ...rest
}) => (
  <svg viewBox="0 0 64 64" width={size} height={size} {...rest}>
    {round ? (
      <circle cx="32" cy="32" r="32" fill={color} style={bgStyle} />
    ) : (
      <rect
        width="64"
        height="64"
        rx={borderRadius}
        ry={borderRadius}
        fill={color}
        style={bgStyle}
      />
    )}

    <path
      d="M 41.116 18.375 h 4.962 l -10.8405 12.39 l 12.753 16.86 H 38.005 l -7.821 -10.2255 L 21.235 47.625 H 16.27 l 11.595 -13.2525 L 15.631 18.375 H 25.87 l 7.0695 9.3465 z m -1.7415 26.28 h 2.7495 L 24.376 21.189 H 21.4255 z"
      fill={iconFillColor}
    />
  </svg>
);

export default XIcon;
